/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Part_Status_OrderedInputs */

const en_part_status_ordered = /** @type {(inputs: Part_Status_OrderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordered`)
};

const ja_part_status_ordered = /** @type {(inputs: Part_Status_OrderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発注済み`)
};

const fr_part_status_ordered = /** @type {(inputs: Part_Status_OrderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandé`)
};

const de_part_status_ordered = /** @type {(inputs: Part_Status_OrderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellt`)
};

/**
* | output |
* | --- |
* | "Ordered" |
*
* @param {Part_Status_OrderedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const part_status_ordered = /** @type {((inputs?: Part_Status_OrderedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Part_Status_OrderedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_part_status_ordered(inputs)
	if (locale === "ja") return ja_part_status_ordered(inputs)
	if (locale === "fr") return fr_part_status_ordered(inputs)
	return de_part_status_ordered(inputs)
});